import React from 'react'
import ReactDOM from 'react-dom/client'
import 'antd/dist/reset.css';
import './index.css';
import App from './App.js';

// Demo mode: seed auth + intercept all API calls before React mounts
if (process.env.REACT_APP_DEMO_MODE === 'true') {
    require('./mocks/demoSetup');
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <App />
);